import React, { useState } from 'react';
import {
  Row,
  Col,
  List,
  Select,
  Button,
  notification,
  InputNumber,
} from 'antd';
import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  DislikeTwoTone,
  LikeTwoTone,
  QuestionOutlined,
  CommentOutlined,
} from '@ant-design/icons';

import {
  saveProcTaskCheck,
  UpdateProcTaskCheckStatus,
  TaskCheckEntityResponse,
} from '../../services/workflow';
import { noop } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
// import InputNumber from 'rc-input-number';
import TextArea from 'antd/lib/input/TextArea';
import UtinaCard from 'components/UtinaCard';

type CheckProps = {
  checks?: TaskCheckEntityResponse[];
  entityReference?: string;
  onSuccess?: () => void;
};

const Check = (props: CheckProps) => {
  const { checks, entityReference, onSuccess = noop } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [selectedAuthid, setSelectedAuthid] = useState(0);
  const [comment, setComment] = useState('');
  const [acceptedvalue, setAcceptedvalue] = useState(0);

  const handleSaveProcTaskCheck = (
    check: TaskCheckEntityResponse,
    status: string,
    withAutid: boolean
  ) => {
    setIsLoading(true);

    //    var status: string = 'INIT';

    if (check.proctaskcheckID != null) {
      if (withAutid === true) {
        if (selectedAuthid === 0) {
          notification.error({ message: 'Please select an Authorization' });
          setIsLoading(false);
          return;
        }
      }
      return UpdateProcTaskCheckStatus({
        proctaskcheckid: check.proctaskcheckID,
        checkstatus: status,
        cteid: check.subobjectid,
        authid: selectedAuthid,
        acceptedvalue: acceptedvalue,
        comment: comment,
      }).then(() => {
        setSelectedAuthid(0);
        setIsLoading(false);
        onSuccess();
      });
    } else {
      saveProcTaskCheck({
        req: {
          ccode: check.ccode,
          checkcode: check.checkcode,
          checkid: check.checkid,
          checkorder: check.checkorder,
          checkrequesttype: check.checkrequesttype,
          checkstatus: status, //'INIT', //check.checkStatus,
          checktype: check.checktype,
          doccode: check.doccode,
          entityid: check.entityid,
          proccode: check.proccode,
          proccodetarget: check.proccodetarget,
          procid: check.procID,
          procmodule: check.procmodule,
          proctaskcheckid: 0, //check.proctaskcheckID,
          proctaskid: check.proctaskID,
          receiverid: check.receiverid,
          receiverroleprofile:
            status === 'OVERRIDE'
              ? check?.notifoverridereceiverroleprofile
              : check.receiverRoleProfile,
          receivertype:
            status === 'OVERRIDE'
              ? check?.notifoverridereceivertype
              : check.receivertype,
          taskid: check.taskid,
          taskidtarget: check.taskidtarget,
          attcode: check.attcode,
          authid: check.authid,
          defaultvalue: check.defaultvalue,
          maxvalue: check.maxvalue,
          minvalue: check.minvalue,
          offerid: check.offerid,
          priid: check.priid,
          requestvalue: check.requestvalue,
          subobject: check.subobject,
          subobjectid: check.subobjectid,
          objectreference: entityReference ?? '',
        },
      }).then((res) => {
        setIsLoading(false);
        onSuccess();
      });
    }
  };

  return (
    <UtinaCard comcode="Check" level={5}>
      <List
        loading={isLoading}
        itemLayout="vertical"
        bordered
        dataSource={checks ?? []}
        renderItem={(check) => (
          <List.Item>
            <Row gutter={24}>
              <Col span={1}>
                {(check.controlCheck === true && (
                  <CheckCircleTwoTone twoToneColor="#52c41a" />
                )) ||
                  (check.controlCheck === false && (
                    <CloseCircleTwoTone twoToneColor="red" />
                  ))}
              </Col>
              <Col span={8}>
                <Row style={{ color: 'blue' }}>&nbsp;{check.clabel}</Row>
                <Row style={{ color: 'green' }}>&nbsp;{check.cmessage}</Row>
              </Col>
              <Col span={15}>
                {check.controlCheck === true && (
                  <>
                    <Row gutter={8}>
                      <Col span={20} style={{ color: 'blue' }}>
                        {check.checkmessage}{' '}
                      </Col>
                      <Col span={4} style={{ color: 'blue' }}>
                        {check.checkStatus === 'INIT' && (
                          <Button
                            style={{ width: 120 }}
                            icon={<DislikeTwoTone twoToneColor="#eb2f96" />}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSaveProcTaskCheck(check, 'REFUS', false);
                            }}
                            type="default"
                          >
                            <GetLabel label="refuse" />
                          </Button>
                        )}
                      </Col>
                    </Row>
                    <Row gutter={8}>
                      <Col span={20}>
                        {check.checkStatus === 'INIT' &&
                          check.attcode !== null && (
                            <>
                              {check.authList && check.authList?.length > 0 && (
                                <>
                                  <Row style={{ marginBottom: '3px' }}>
                                    <Col span={10}>Select Authorization :</Col>
                                    <Col span={14}>
                                      <Select
                                        style={{ width: '100%' }}
                                        allowClear
                                        onSelect={(value: number) =>
                                          setSelectedAuthid(value)
                                        }
                                      >
                                        {check.authList?.map(
                                          (
                                            {
                                              authid,
                                              userjob,
                                              valuemin,
                                              valuemax,
                                            },
                                            i
                                          ) => (
                                            <Select.Option
                                              value={authid}
                                              key={authid}
                                            >
                                              {userjob +
                                                ' : Min : ' +
                                                valuemin +
                                                ' - Max : ' +
                                                valuemax}
                                            </Select.Option>
                                          )
                                        )}
                                      </Select>
                                    </Col>
                                  </Row>

                                  <Row style={{ marginBottom: '3px' }}>
                                    <Col span={10}>
                                      Enter authorized value :
                                    </Col>
                                    <Col span={14}>
                                      <InputNumber
                                        onChange={
                                          (
                                            value: number | null // Ancien code : onChange={(value: number) =>
                                          ) => setAcceptedvalue(value ?? 0) // Ancien code : setAcceptedvalue(value)
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </>
                              )}
                              <Row>
                                <Col span={10}>Enter Comment / Message :</Col>
                                <Col span={14}>
                                  <TextArea
                                    rows={3}
                                    onChange={(e: any) =>
                                      setComment(e.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                            </>
                          )}
                      </Col>
                      <Col span={4}>
                        {check.checkStatus === 'INIT' && (
                          <>
                            <Button
                              style={{ width: 120 }}
                              icon={<LikeTwoTone twoToneColor="#52c41a" />}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSaveProcTaskCheck(
                                  check,
                                  'ACCEPT',
                                  check.attcode === 'RV' ||
                                    check.attcode === 'FR' ||
                                    check.attcode === 'RATE' ||
                                    check.attcode === 'DURATION' ||
                                    check.attcode === 'ATTRIBUTE'
                                    ? true
                                    : false
                                );
                              }}
                              type="default"
                            >
                              <GetLabel label="accept" />
                            </Button>
                            <Button
                              style={{ width: 120 }}
                              icon={<CommentOutlined twoToneColor="#52c41a" />}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSaveProcTaskCheck(
                                  check,
                                  'RESERVE',
                                  check.attcode === 'RV' ||
                                    check.attcode === 'FR' ||
                                    check.attcode === 'RATE' ||
                                    check.attcode === 'DURATION' ||
                                    check.attcode === 'ATTRIBUTE'
                                    ? true
                                    : false
                                );
                              }}
                              type="default"
                            >
                              <GetLabel label="reserve" />
                            </Button>
                          </>
                        )}
                      </Col>
                    </Row>
                  </>
                )}
                {check.controlCheck === false && (
                  <Row gutter={8}>
                    <Col span={20} style={{ color: 'green' }}>
                      {check.checkmessage}
                    </Col>

                    <Col span={4} style={{ color: 'blue' }}>
                      {check.checkrequesttype === 'REQVAL' &&
                        check.checkStatus === 'INIT' && (
                          <Button
                            style={{ width: 120 }}
                            icon={<CloseCircleTwoTone twoToneColor="#eb2f96" />}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSaveProcTaskCheck(check, 'CANCEL', false);
                            }}
                            type="default"
                          >
                            <GetLabel label="cancel" />
                          </Button>
                        )}
                      {check.checkrequesttype === 'REQVAL' &&
                        check.checkStatus === '' && (
                          <Button
                            style={{ width: 120 }}
                            icon={<QuestionOutlined />}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSaveProcTaskCheck(check, 'INIT', false);
                            }}
                            type="default"
                          >
                            <GetLabel label="Ask" />
                          </Button>
                        )}
                      {check.checkrequesttype === 'OVERRIDE' && (
                        <Button
                          style={{ width: 120 }}
                          icon={<LikeTwoTone twoToneColor="#eb2f96" />}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSaveProcTaskCheck(check, 'OVERRIDE', false);
                          }}
                          type="default"
                        >
                          <GetLabel label="Override" />
                        </Button>
                      )}
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </List.Item>
        )}
      />
    </UtinaCard>
  );
};

export default Check;
